export default __webpack_public_path__ + "resources/icons/d341-463f.png";